export const CATALOG_FORM_SUBMITTED_KEY = 'catalog:form:submitted';
export const CATALOG_FORM_SUBMITTED_AT_KEY = 'catalog:form:submitted_at';
export const CATALOG_FORM_SUBMITTING_KEY = 'catalog:form:submitting';

export const CATALOG_SERIAL_CODE_KEY = 'catalog:serial_code';
export const CATALOG_SERIAL_CODE_TIMESTAMP_KEY = 'catalog:serial_code_timestamp';
